import axios from 'axios';
import { notify } from '@lib/bugsnag';
import {
  BridgeTxApiSingleReponse,
  BridgeTxApiSingleResultStatus,
} from '@types';
import { NotifiableError } from '@bugsnag/core';
import staticConfig from '@config/static-config';

const useTxPolling = () => {
  const pollTx = (
    callback: (data: BridgeTxApiSingleReponse) => void,
    txsId: string,
    {
      delay = 10000,
      isTestnet = true,
    }: {
      delay?: number;
      isTestnet?: boolean;
    } = {}
  ) => {
    const txsApiBaseUrl = isTestnet
      ? staticConfig.txsApi.testnet.baseUrl
      : staticConfig.txsApi.mainnet.baseUrl;
    const intervalId = setInterval(async () => {
      try {
        const { data } = await axios.get(`${txsApiBaseUrl}/txs/${txsId}`);
        callback(data);
        if (data.result.status !== BridgeTxApiSingleResultStatus.pending) {
          // status counterpartyConfirmed or counterpartyRejected doesnt mean
          // we have the destination transaction id. This ID might be fetch slightly more after.
          if (
            (data.result.status ===
              BridgeTxApiSingleResultStatus.counterpartyConfirmed ||
              data.result.status ===
                BridgeTxApiSingleResultStatus.counterpartyRejected) &&
            !data.result.destinationTransactionId
          )
            return;
          clearInterval(intervalId);
        }
      } catch (error) {
        notify(error as NotifiableError);
      }
    }, delay);
  };

  return pollTx;
};

export default useTxPolling;
